import { useState } from 'react';
import { useSelector } from 'react-redux';
import { createUserN, getOAuthTokenGoogle } from '@/services/userService';
import { sendWelcomeEmail } from '@/services/emailService';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setUser } from '@/redux/actions/userActions';
import { getOAuthToken } from '@/services/userService';

export const useSignUp = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [loginType, setLoginType] = useState(null);
  const [googleError, setGoogleError] = useState(null);
  const languageData = useSelector((state) => state.lenguage?.lang);

  const closeModal = () => {
    setShowModal(false);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const goHome = () => {
    setShowModal(false);
    navigate('/');
  };

  const handleSubmit = async (values, resetForm) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const payload = {
        user_id: 99,
        user_name: values.name,
        user_lastname: values.lastname,
        user_email: values.email,
        user_idnumber: '9',
        user_phone: '',
        main_image: '',
        password: values.password,
        fecreg: '2025-01-19',
        id_state: 1,
        enabled: true,
        account_expired: false,
        credentials_expired: false,
        account_locked: false,
      };

      await createUserN(payload);
      console.log('Usuario creado correctamente');

      const tokenData = await getOAuthToken({
        username: values.email,
        password: values.password,
      });

      const userData = {
        name: values.name,
        lastName: values.lastname,
        email: values.email,
        user_id: tokenData?.user_details?.user_id,
        google: false,
      };

      dispatch(setUser(userData));

      localStorage.setItem('user', JSON.stringify(userData));
      localStorage.setItem('access_token', tokenData.access_token);
      localStorage.setItem('refresh_token', tokenData.refresh_token);
      localStorage.setItem(
        'auth_data',
        JSON.stringify({
          token_type: tokenData.token_type,
          expires_in: tokenData.expires_in,
          scope: tokenData.scope,
        }),
      );

      const templateParams = {
        user_name: userData?.name,
        user_email: userData?.email,
        reply_to: userData?.email,
        copy_to: 'sistemas@popnest.org',
        message: 'Estimado usuario, sea bienvenido a popnest',
      };

      sendWelcomeEmail(templateParams)
        .then(() => console.log('Email estático enviado correctamente'))
        .catch((err) => console.error('Error enviando email estático:', err));

      setSuccess(true);
      setLoginType('register');
      setShowModal(true);

      if (resetForm) {
        resetForm();
      }

      return tokenData;
    } catch (err) {
      console.error(err);

      const rawMessage =
        err?.response?.data?.error || err?.response?.data?.message || err?.message || '';

      if (
        rawMessage.toLowerCase().includes('unique') ||
        rawMessage.toLowerCase().includes('duplicate')
      ) {
        setError(
          languageData === 'EN'
            ? 'The email has already been created, please try another one.'
            : 'El usuario con ese correo ya ha sido creado, por favor intente con otro correo.',
        );
      } else {
        setError(
          languageData === 'EN'
            ? 'Error creating account. Please try again.'
            : 'Error creando la cuenta. Por favor intente nuevamente.',
        );
      }

      throw err;
    } finally {
      setLoading(false);
    }
  };

  const loginWithGoogleOAuth = async ({ username, googleToken }) => {
    setLoading(true);
    setGoogleError(null);
    setError(null);

    try {
      const tokenData = await getOAuthTokenGoogle({
        username,
        googleToken,
      });

      setLoginType('google');
      setShowModal(true);

      return tokenData;
    } catch (err) {
      const apiError =
        err?.response?.data?.error ||
        err?.response?.data?.code ||
        err?.response?.data?.message ||
        err?.message ||
        '';

      if (String(apiError).toLowerCase().includes('bad')) {
        setGoogleError(
          languageData === 'EN'
            ? 'The user has already been registered previously with this email'
            : 'El usuario ya fue registrado previamente con este email',
        );
      } else {
        setGoogleError(
          languageData === 'EN'
            ? 'Could not sign in with Google'
            : 'No se pudo iniciar sesión con Google',
        );
      }

      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    googleError,
    success,
    handleSubmit,
    loginWithGoogleOAuth,
    showModal,
    loginType,
    closeModal,
    goHome,
  };
};
